import { useTranslation } from "react-i18next";
import { Briefcase } from "lucide-react";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const EmployeeContractSection = ({ formData, updateField, sites }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <Briefcase className="h-4 w-4" />
        <span>{t("employeesPage.sections.contractRole")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="contract_type">{t("employeesPage.labels.contractType")}</Label>
          <Select value={formData.contract_type} onValueChange={(v) => updateField("contract_type", v)}>
            <SelectTrigger><SelectValue placeholder={t("employeesPage.labels.contractType")} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="PERMANENT">{t("employeesPage.contractType.permanent")}</SelectItem>
              <SelectItem value="TEMPORARY">{t("employeesPage.contractType.fixedTerm")}</SelectItem>
              <SelectItem value="INTERNSHIP">{t("employeesPage.contractType.internship")}</SelectItem>
              <SelectItem value="FREELANCE">{t("employeesPage.contractType.freelance")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="role">{t("employeesPage.labels.role")}</Label>
          <Select value={formData.role} onValueChange={(v) => updateField("role", v)}>
            <SelectTrigger><SelectValue placeholder={t("employeesPage.placeholders.role")} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="EMPLOYEE">{t("employeesPage.roles.employee")}</SelectItem>
              <SelectItem value="SUPERVISOR">{t("employeesPage.roles.supervisor")}</SelectItem>
              <SelectItem value="MANAGER">{t("employeesPage.roles.manager")}</SelectItem>
              <SelectItem value="HR">{t("employeesPage.roles.hr")}</SelectItem>
              <SelectItem value="ADMIN">{t("employeesPage.roles.admin")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="site_id">{t("employeesPage.labels.site")}</Label>
          <Select value={formData.site_id} onValueChange={(v) => updateField("site_id", v)}>
            <SelectTrigger><SelectValue placeholder={t("employeesPage.placeholders.site")} /></SelectTrigger>
            <SelectContent className="max-h-60 overflow-y-auto">
              {sites.map((site) => (
                <SelectItem key={site.id} value={site.id.toString()}>
                  {site.name}{site.city ? ` - ${site.city}` : ""}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default EmployeeContractSection;
